import React                          from 'react';
import { WithStyle, withStyles }      from 'rewire-ui';
import { Theme }                      from '@material-ui/core/styles';
import OtherPaymentsView              from '../../timecard/OtherPaymentsView';
import timecardTestOtherPaymentsModel from './TimecardTestOtherPaymentsModel';

const styles = (_theme: Theme) => ({
});

interface ITimecardTestOtherPaymentsProps {
}

type TimecardTestOtherPaymentsProps = WithStyle<ReturnType<typeof styles>, ITimecardTestOtherPaymentsProps>;

class TimecardTestOtherPaymentsView extends React.PureComponent<TimecardTestOtherPaymentsProps> {
  constructor(props: TimecardTestOtherPaymentsProps) {
    super(props);
  }

  render() {
    return (
      <OtherPaymentsView model={timecardTestOtherPaymentsModel} />
    );
  }
}

export default withStyles<ITimecardTestOtherPaymentsProps, unknown>(styles, TimecardTestOtherPaymentsView);